import {
  WbSelectInline,
  WbSelectInlineItem,
} from '@agilelab/plugin-wb-platform';
import { camelToSpacedCase } from '@agilelab/plugin-wb-platform-common';
import { Box, Theme, Typography, makeStyles } from '@material-ui/core';
import pluralize from 'pluralize';
import { useManageAssignmentsDrawerContext } from './ManageAssignmentsDrawerContext';
import { ScopeEnum } from './types';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

export function EntityKindSelector({ disabled }: { disabled?: boolean }) {
  const classes = useStyles();
  const { selectedKind, setSelectedKind } = useManageAssignmentsDrawerContext();

  const kinds = [
    { key: 'domains', value: ScopeEnum.domain },
    { key: 'systems', value: ScopeEnum.system },
    { key: 'systemTypes', value: ScopeEnum.systemType },
  ];

  return (
    <Box className={classes.container}>
      <Typography variant="body2" color="secondary">
        Category:
      </Typography>

      <WbSelectInline
        value={selectedKind}
        onChange={setSelectedKind}
        disabled={disabled}
      >
        {...kinds.map(i => (
          <WbSelectInlineItem {...i}>
            <Typography variant="body2">
              {camelToSpacedCase(pluralize(i.key), true)}
            </Typography>
          </WbSelectInlineItem>
        ))}
      </WbSelectInline>
    </Box>
  );
}
